import { RootState } from "@base/store";
import Button from "@components/atoms/button";
import CalendarField from "@components/atoms/date-picker/datePicker.atom";
import TextField from "@components/atoms/input";
import theme from "@config/theme";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

import { Container, Content, FieldsWrapper, Form } from "./editProfile.styled";
import { EditProfileProps } from "./editProfile.type";

const EditProfile = ({
  formik,
  handleSubmit,
  handleDateChange,
}: EditProfileProps) => {
  const user = useSelector((state: RootState) => state.user.user);

  return (
    <Container>
      <Content>
        <Form>
          <FieldsWrapper>
            <TextField
              name={"firstName"}
              placeholder="First Name"
              label="First Name"
              value={formik.values.firstName}
              touched={formik.touched.firstName}
              error={formik.errors.firstName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <TextField
              name={"lastName"}
              placeholder="Last Name"
              label="Last Name"
              value={formik.values.lastName}
              touched={formik.touched.lastName}
              error={formik.errors.lastName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <CalendarField
              name="dob"
              label="Date Of Birth"
              onChange={handleDateChange}
              value={formik.values.dob}
              errorMessage={formik.errors.dob}
            />
            <TextField
              name={"email"}
              placeholder="Email address"
              label="Email"
              disabled
              value={user?.email}
              touched={formik.touched.email}
              error={formik.errors.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </FieldsWrapper>
          <Box>
            <Button
              textColor={theme.palette.grey[100]}
              color="primary"
              isDisabled={!(formik.isValid && formik.dirty)}
              text={"Save"}
              type={"button"}
              onClick={() => {
                handleSubmit();
              }}
            />
          </Box>
        </Form>
      </Content>
    </Container>
  );
};

export default EditProfile;
